/**
 * Issuers, as two-character codes.
 *
 * The id is already short — "hamilton", "harvest" — but it is on every one of
 * the 127 records, which makes it 2.4K of the artefact to say one of two
 * things.
 *
 * Two characters rather than one: seven issuers are listed and more will be,
 * and a single letter runs out of distinct initials quickly. `is` and `gx` are
 * the two that would have collided.
 */
export const ISSUER_CODES: Record<string, string> = {
    ha: 'hamilton',
    hv: 'harvest',
    ev: 'evolve',
    bm: 'bmo',
    is: 'ishares',
    va: 'vanguard',
    gx: 'globalx',
};

const BY_ID: Record<string, string> = Object.fromEntries(Object.entries(ISSUER_CODES).map(([code, id]) => [id, code]));

export const issuerId = (code: string | null | undefined): string | null => (code ? (ISSUER_CODES[code] ?? code) : null);
export const codeForIssuer = (id: string | null | undefined): string | null => (id ? (BY_ID[id] ?? null) : null);
